// TODO: Move all the prompts here
export const PROMPTS = {
  teachingGuide: 'lpCerebroTeachingGuide',
};
